/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'skymx';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password: password.replace(/[\u00A0-\u9999<>&]/g, (i) => '&#' + i.charCodeAt(0) + ';'),
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Usuario y/o clave incorrectas. Por favor reintente nuevamente.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <>
        <div className="login-skymx-container" ref={nodeRef}>
          <Form onSubmit={(event) => onSubmit(event)}>
            <Container fluid={true} className="skymx-form-container">
              <Row className="skymx-form-header">
                <Col sm="12" xs="12" md="12">
                  <p className="login-title">Inicia sesión</p>
                </Col>
              </Row>
              <Row className="skymx-form-body">
                <Col sm="12" xs="12" md="12" className="skymx-input">
                  <div className="input-container">
                    <Input
                      className="user-input-skymx"
                      disabled={onLogin}
                      required={true}
                      tabIndex={1}
                      type="text"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="username"
                      onChange={e => setUsername(e.target.value)}
                      placeHolder={translate("PlaceholderUserName")}
                    />
                  </div>
                </Col>
                <Col sm="12" xs="12" md="12" className="skymx-input">
                  <div className="input-container">
                    <Input
                      className="pass-input-skymx"
                      required={true}
                      disabled={onLogin}
                      tabIndex={1}
                      type="password"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="password"
                      placeHolder={translate("PlaceholderPassword")}
                      onChange={e => setPassword(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              {!onLogin ? (
                <button
                  block={!parameters.failureRedirect}
                  tabIndex={1}
                  type="submit"
                  id="submmit"
                  className="enter-skymx"
                  disabled={!props.turnstileSuccess}
                >
                  {translate("ButtonEnter")}
                </button>
              ) : (
                <Progress animated color="danger" value={100} />
              )}
              {/* <div className="skymx-links">
                  <p className="url"><a style={{ color: 'black' }} href="https://serviciosenlinea.sky.com.mx/" target="_blank" rel="noopener noreferrer" className="url">Recuperar contraseña</a></p>
                  {checkDeviceIOS() ? '' : <p style={{ color: 'black'}}>Aun no estás registrado? <a href="https://serviciosenlinea.sky.com.mx/" target="_blank" rel="noopener noreferrer"> Hazlo ahora</a></p>}
                </div> */}

              {/* No borrar estos comentarios, se volverán a prender en el futuro cercano por orden de skymx con las url modificadas*/}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </Container>
          </Form>
        </div>
      </>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
